import BigNumber from 'bignumber.js';

export default function applyVat (value, vatValue) {
  let bigValue = value;
  let convertToNumber = false;
  if (!(bigValue instanceof BigNumber)) {
    bigValue = new BigNumber(bigValue);
    convertToNumber = true;
  }
  const valueWithVat = bigValue.times(vatValue);
  if (convertToNumber) {
    return parseFloat(valueWithVat.toFixed(2));
  }
  return valueWithVat;
}

export const withoutVat = (value, vatDivider) => {
  if (!vatDivider) {
    return value;
  }

  return new BigNumber(value || 0).
    div(vatDivider).
    toFixed(2);
};
